import React from 'react';
import Row1 from './Row1';
import Row2 from './Row2';

function TimeLine() {
    return (
        <div className="timeline">
            <div className="line"></div>

            <Row2
                heading="Bugsmirror"
                category="Work Experience"
                time="Jan (2021) - Mar (2021)"
                content="Flutter Developer Intern"
            />
            <Row1
                heading="Helping Wind"
                category="Work Experience"
                time="Sep (2020) - Nov (2020)"
                content="Frontend Developer Intern" 
            />

            <Row2
                heading="AXIS Junior Scientist 2020"
                category="Volunteer Experience"
                time="Jan (2020) - Feb (2020)"
                content="Organizer & Publicity Member"
            />

            <Row1
                heading="Aarohi VNIT"
                category="Volunteer Experience"
                time="Oct (2018) - Current"
                content="Organizer , Publicity & Hospitality Member" 
            />

            <Row2
                heading="Visvesvaraya National Institute of Technology"
                category="Education"
                time="(2018) - (2022) Expected"
                content="Computer Science and Engineering"
            />

        </div>
    );
}

export default TimeLine;